import React from 'react'
import ArrowDownward from '@mui/icons-material/ArrowDownward'
import ArrowUpward from '@mui/icons-material/ArrowUpward'
import SwapVert from '@mui/icons-material/SwapVert'
import { Button } from '@mui/material'

export default function SortingHandler({
  sortValue,
  setSortValue,
  sortOptions,
  getOptionLabel,
  getOptionValue,
  outerDivStyle,
  buttonColor = 'primary',
  buttonVariant = 'outlined',
}) {
  // sort value will have something like sort modifiedDetails,asc where modifiedDetails is the field to sort by and asc is the order
  const currentSortField = sortValue?.split(',')[0]
  const currentSortOrder = sortValue?.split(',')[1]

  function handleSort(option) {
    //cycle between acs desc and unsorted
    if (currentSortField === getOptionValue(option)) {
      if (currentSortOrder === 'asc') {
        setSortValue(`${getOptionValue(option)},desc`)
      } else {
        setSortValue(null)
      }
    } else {
      setSortValue(`${getOptionValue(option)},asc`)
    }
  }

  return (
    <div className="d-flex justify-content-center gap-1" style={outerDivStyle}>
      <strong style={{fontSize: '1em'}}>Sort By: </strong>
      {sortOptions?.map((option) => (
        <Button
          key={getOptionValue(option)}
          onClick={() => handleSort(option)}
          sx={{
            fontSize: '1em !important',
          }}
          variant={buttonVariant}
          color={buttonColor}
          size="small"
        >
          {getOptionLabel(option)}{' '}
          {currentSortField === getOptionValue(option) ? (
            currentSortOrder === 'asc' ? (
              <ArrowUpward sx={{ fontSize: '1.2rem' }} />
            ) : (
              <ArrowDownward sx={{ fontSize: '1.2rem' }} />
            )
          ) : (
            <SwapVert sx={{ fontSize: '1.2rem' }} />
          )}
        </Button>
      ))}
    </div>
  )
}
